import type { ExperimentKeyValue, ExperimentResult } from "@rflocal/shared/experiments";

/**
 * Evaluate an experiment via the backend.
 *
 * Calls GET /query/experiment which evaluates the flag server-side through
 * posthog-node, making it adblocker-proof.
 */
export async function getExperiment(
    key: ExperimentKeyValue,
    distinctId: string
): Promise<ExperimentResult> {
    const params = new URLSearchParams({ key, distinctId });

    const response = await fetch(`/query/experiment?${params}`);

    if (!response.ok) {
        throw new Error(`ExperimentApiError: ${response.status}`);
    }

    return response.json();
}

export default { getExperiment };
